import merge from 'lodash/merge'

import baseButtonStyles from '../BaseButton/BaseButton.styles'
import baseStyles from '../Base/Base.styles'

export default ({
  base,
  declineButton,
  confirmButton
}) => {

  let jss = {
    root: {
      ...baseStyles(base),
    }
  }

  merge(jss.root, {
    '& .confirm-button': baseButtonStyles(confirmButton),
    '& .decline-button': baseButtonStyles(declineButton)
  })

  return jss
}
